"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = require("material-ui/TextField");

var _TextField2 = _interopRequireDefault(_TextField);

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hintBaseStyle = {
  fontSize: "16px",
  letterSpacing: "0.7px",
  color: "rgba(0, 0, 0, 0.3799999952316284)"
};

var floatingLabelBaseStyle = {
  top: 30,
  fontSize: "14px",
  letterSpacing: "0.6px"
};

var floatingLabelBaseShrinkStyle = {
  fontSize: "12px",
  color: "rgba(0, 0, 0, 0.6000000238418579)",
  transform: "scale(1) translate(0px, -16px)",
  fontWeight: 500,
  zIndex: 0
};

var inputBaseStyle = {
  paddingBottom: 10,
  fontSize: "16px",
  color: "#484848",
  letterSpacing: "0.7px"
};

var requiredStyle = {
  color: "red"
};

var underlineDisabledStyle = {
  borderBottom: "1px solid #e0e0e0"
};

var underlineFocusBaseStyle = {
  borderColor: "#e0e0e0"
};

var TextField = function TextField(_ref) {
  var style = _ref.style,
      onChange = _ref.onChange,
      id = _ref.id,
      disabled = _ref.disabled,
      _ref$floatingLabelSty = _ref.floatingLabelStyle,
      floatingLabelStyle = _ref$floatingLabelSty === undefined ? {} : _ref$floatingLabelSty,
      hintText = _ref.hintText,
      errorText = _ref.errorText,
      _ref$errorStyle = _ref.errorStyle,
      errorStyle = _ref$errorStyle === undefined ? {} : _ref$errorStyle,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === undefined ? true : _ref$fullWidth,
      _ref$hintStyle = _ref.hintStyle,
      hintStyle = _ref$hintStyle === undefined ? {} : _ref$hintStyle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      _ref$value = _ref.value,
      value = _ref$value === undefined ? "" : _ref$value,
      floatingLabelText = _ref.floatingLabelText,
      _ref$underlineShow = _ref.underlineShow,
      underlineShow = _ref$underlineShow === undefined ? true : _ref$underlineShow,
      _ref$inputStyle = _ref.inputStyle,
      inputStyle = _ref$inputStyle === undefined ? {} : _ref$inputStyle,
      _ref$underlineFocusSt = _ref.underlineFocusStyle,
      underlineFocusStyle = _ref$underlineFocusSt === undefined ? {} : _ref$underlineFocusSt,
      required = _ref.required,
      type = _ref.type,
      autoFocus = _ref.autoFocus,
      maxLength = _ref.maxLength,
      multiLine = _ref.multiLine,
      ErrorText = _ref.ErrorText,
      errorMessage = _ref.errorMessage,
      dropDownData = _ref.dropDownData,
      dataFetchConfig = _ref.dataFetchConfig,
      jsonPath = _ref.jsonPath,
      toolTip = _ref.toolTip,
      updateDependentFields = _ref.updateDependentFields,
      toolTipMessage = _ref.toolTipMessage,
      rest = (0, _objectWithoutProperties3.default)(_ref, ["style", "onChange", "id", "disabled", "floatingLabelStyle", "hintText", "errorText", "errorStyle", "fullWidth", "hintStyle", "className", "value", "floatingLabelText", "underlineShow", "inputStyle", "underlineFocusStyle", "required", "type", "autoFocus", "maxLength", "multiLine", "ErrorText", "errorMessage", "dropDownData", "dataFetchConfig", "jsonPath", "toolTip", "updateDependentFields", "toolTipMessage"]);

  return _react2.default.createElement(
    "div",
    { className: "All-common-input" },
    _react2.default.createElement(_TextField2.default, (0, _extends3.default)({
      errorText: errorText,
      errorStyle: errorStyle,
      value: value,
      onChange: onChange,
      disabled: disabled,
      inputStyle: (0, _extends3.default)({}, inputBaseStyle, inputStyle),
      className: "textfield " + className,
      style: style,
      id: id,
      floatingLabelShrinkStyle: floatingLabelBaseShrinkStyle,
      fullWidth: fullWidth,
      hintText: hintText,
      hintStyle: (0, _extends3.default)({}, hintBaseStyle, hintStyle),
      floatingLabelText: [floatingLabelText, required ? _react2.default.createElement(
        "span",
        { key: "error-" + className, style: requiredStyle },
        " ",
        "*"
      ) : null],
      floatingLabelStyle: (0, _extends3.default)({}, floatingLabelBaseStyle, floatingLabelStyle),
      underlineFocusStyle: (0, _extends3.default)({}, underlineFocusBaseStyle, { underlineFocusStyle: underlineFocusStyle }),
      underlineShow: underlineShow,
      floatingLabelFixed: true,
      type: type,
      autoFocus: autoFocus,
      maxLength: maxLength,
      autoComplete: type === "password" ? "new-password" : "off"
      //  autoComplete={"off"}
      , multiLine: multiLine,
      underlineDisabledStyle: underlineDisabledStyle
    }, rest))
  );
};

TextField.propTypes = {
  onChange: _propTypes2.default.func,
  errorText: _propTypes2.default.string,
  errorStyle: _propTypes2.default.object,
  value: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  hintText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  required: _propTypes2.default.bool,
  hide: _propTypes2.default.bool,
  floatingLabelText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  className: _propTypes2.default.string
};

exports.default = TextField;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/TextField/index.js
// module id = ../lib/egov-ui-kit/components/TextField/index.js
// module chunks = 504